import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1669846125517-6ea5fd9dc9af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b3JraW5nJTIwbGFwdG9wJTIwd2FybSUyMHdpbmRvd3xlbnwwfHx8fDE3ODg0NzIwMjV8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      navigate(u.role === "admin" ? "/admin" : "/culture", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Sign in" subtitle="Access your GIC&E contractor pre-screening portal." image={IMG}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email Address</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email" placeholder="you@example.com" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-sm text-[#2C5545] hover:underline" data-testid="forgot-link">
              Forgot password?
            </Link>
          </div>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={busy} data-testid="login-submit"
          className="w-full bg-[#2C5545] hover:bg-[#224336] rounded-lg py-6 text-base font-semibold transition-transform hover:-translate-y-[1px]">
          {busy ? "Signing in…" : "Sign In"}
        </Button>
        <p className="text-center text-sm text-[#515E58]">
          Invited to apply?{" "}
          <Link to="/register" className="font-medium text-[#2C5545] hover:underline" data-testid="register-link">
            Create your account
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
